import type { IconSvgObject } from './types';

const MoonEclipseIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 1.99997C15.0571 3.27423 18 7.52235 18 12C18 16.4776 15.0571 20.7257 11 22", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MoonEclipseIcon;
